import AbstractRepository from "@/repositories/AbstractRepository";

export default class PlaceLinkingRepository extends AbstractRepository {
    protected static resource: string = "placelinking";

    public static defaultFields: string[] = [
        "uuid",
        "geomarket",
        "selected",
        "owner.uuid",
        "place.uuid",
        "place.cospiritCode",
        "place.category",
        "place.brand",
        "place.name",
        "place.address",
        "place.postalCodeCity",
    ];
}
